// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-test-jsx": () => import("./../src/pages/test.jsx" /* webpackChunkName: "component---src-pages-test-jsx" */),
  "component---src-pages-wanderers-boiler-jsx": () => import("./../src/pages/wanderers-boiler.jsx" /* webpackChunkName: "component---src-pages-wanderers-boiler-jsx" */)
}

